export class Mapper {
    constructor(mapper) {
        this.mapper = mapper;
    }
 
    split(data) {
        const result = {...data};
        Object.keys(this.mapper).forEach(key => {
            const value = result[key];
            delete result[key];
            if (!value || typeof value !== 'object') {
                return;
            }
            Object.keys(this.mapper[key]).forEach(item => {
                result[item] = value[this.mapper[key][item]];
            });
        });
        return result;
    }

    join(data, deleteOrigin = true) {
        const result = {...data};
        const mapperData = {};
        Object.keys(this.mapper).forEach(key => {
            mapperData[key] = {};
            Object.keys(this.mapper[key]).forEach(item => {
                const attrKey = this.mapper[key][item];
                mapperData[key][attrKey] = result[item];
                if (deleteOrigin) {
                    delete result[item];
                }
                
            });
        });
        return Object.assign({}, result, mapperData);
    }
 }